'use client';

import './index.css';

import { storyblokEditable } from '@storyblok/react';
import classNames from 'classnames';
import { useEffect, useState } from 'react';

import { Star } from '@/components/icons';
import { MaxWidth } from '@/components/max-width';

import { markdownToHtml } from '@/helpers/string';

export const TabsClient = ({ blok, itemsChildren }) => {
  const [current, setCurrent] = useState(0);
  const [prev, setPrev] = useState(null);

  useEffect(() => {
    if (prev !== null) {
      const timeout = setTimeout(() => {
        setPrev(null);
      }, 350);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [prev]);

  return (
    <div {...storyblokEditable(blok)} className={classNames('tabs')}>
      <MaxWidth>
        <div className="tabs__nav">
          {blok.items.map((item, index) => {
            return (
              <button
                {...storyblokEditable(item)}
                key={item._uid}
                type="button"
                className={classNames('tabs__nav__item', {
                  'tabs__nav__item--active': current === index,
                })}
                onClick={() => {
                  setPrev(current);
                  setCurrent(index);
                }}
              >
                <span className="tabs__nav__item__icon" aria-hidden="true">
                  <Star />
                </span>

                {item.title ? (
                  <span
                    className="tabs__nav__item__title"
                    dangerouslySetInnerHTML={{
                      __html: markdownToHtml(item.title),
                    }}
                  />
                ) : null}
              </button>
            );
          })}
        </div>

        <div className="tabs__content">
          {itemsChildren.map((item, index) => {
            return (
              <div
                key={index}
                className={classNames('tabs__content__item', {
                  'tabs__content__item--active': current === index,
                  'tabs__content__item--out': prev === index,
                })}
              >
                {item}
              </div>
            );
          })}
        </div>
      </MaxWidth>
    </div>
  );
};
